/**
 * Production Mode Overrides
 * Allows QA to switch from QA domains to production domains at runtime
 * without rebuilding the app.
 */

import CookieStorage from "library/core/utility/cookie-storage";

const PRODUCTION_MODE_KEY = "qa_production_mode";

/**
 * Explicit config key → production value overrides.
 * Only these keys are replaced when production mode is enabled.
 */
export const PRODUCTION_OVERRIDES: Record<string, string> = {
  apiUrl: "https://beta-api.cams.com",
  broadcastApiUrl: "https://beta-api.cams.com",
  broadcastApiSocket: "wss://beta-api.cams.com",
  broadcastRtmp: "rtmp://origins.streamray.com:1935",
  broadcastRtmpVr: "rtmp://origins.streamray.com:1935",
  broadcastWs: "wss://origins.streamray.com",
  webrtcApp: "webrtc",
  broadcastEdge: "edge",
  broadcastApp: "origin",
  broadcastAppVr: "xr",
  membersUrl: "https://cams.com",
};

export const isProductionMode = (): boolean => {
  return !!CookieStorage.get(PRODUCTION_MODE_KEY);
};

export const setProductionMode = (enabled: boolean): void => {
  if (enabled) {
    CookieStorage.set(PRODUCTION_MODE_KEY, true);
  } else {
    CookieStorage.remove(PRODUCTION_MODE_KEY);
  }
};

export const applyProductionOverrides = <T extends Record<string, any>>(
  config: T
): T => {
  if (!isProductionMode()) return config;

  const result = { ...config };
  for (const key in PRODUCTION_OVERRIDES) {
    if (key in result) {
      (result as any)[key] = PRODUCTION_OVERRIDES[key];
    }
  }
  return result;
};
